// OAuthSuccess.jsx (or similar component)
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const OAuthSuccess = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect back to originally requested path if stored
    const redirectTo = localStorage.getItem("postLoginRedirect");
    if (redirectTo) {
      localStorage.removeItem("postLoginRedirect");
      navigate(redirectTo, { replace: true });
    } else {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  return <div>Processing...</div>;
};

export default OAuthSuccess;
